import { Grid, LinearProgress } from '@mui/material';
import { ProductSelection } from '../../../constants/constant';
import ProductDetailsBox from './product-details-box';
import { toggleDrawerParentItemOpportunity } from '../../store/planner-slice';
import useProductDrawer from './product-drawer.hook';

/**
 * Drawer content for SKU
 */
export default function SKUDrawer() {
  const {
    handleAddComment,
    isLoading,
    product,
    ppgId,
    appDispatch,
    handleDeleteComment,
    handleUpdateComment,
    plannerAccessConfig
  } = useProductDrawer({ toggle: ProductSelection.sku });
  if (isLoading || !product.parent_details) {
    return <LinearProgress />;
  }
  return (
    <Grid container>
      <Grid item xs={12} mb={1}>
        <ProductDetailsBox
          isPPGBox
          opportunities={product.opportunities.sku}
          productDetails={product.parent_details}
          isExpandable={false}
          isOpen={false}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          toggleExpandableState={null}
          onCommentAdd={(comment) =>
            handleAddComment(comment, ppgId, product.parent_details.id, null)
          }
          isOpportunitiesSelectionDisabled={
            !plannerAccessConfig?.change_own_opportunity
          }
          onCommentDelete={handleDeleteComment}
          onCommentUpdate={handleUpdateComment}
          onOpportunitySelection={(
            isOpportunityChecked,
            selectedOpportunities,
            changedOpportunity
          ) => {
            appDispatch(
              toggleDrawerParentItemOpportunity({
                changedOpportunity,
                isOpportunityChecked,
                selectedOpportunities
              })
            );
          }}
        />
      </Grid>
    </Grid>
  );
}
